<template>
  <div class="container">
    <div class="row h-50">
      <div
        v-if="loading"
        class="row d-flex justify-content-center align-middle my-4"
      >
        <h3>Loading magical things :)</h3>
      </div>
      <div class="col-8 offset-2 my-4" v-else>
        <h2 class="message">Delete your Digital Key!!!!</h2>
        <p>Please only use a KeyInfoId, if you dont know dont enter it.</p>
        <p>
          <label class="message" for="keyInfoId">KeyInfoId</label>
          <input
            class="form-control my-2"
            id="keyInfoId"
            v-model="keyInfoId"
            type="text"
            name="keyInfoId"
          />
          <label class="message" for="selected">Select an environment</label>
          <select
            class="form-select my-2"
            aria-label="Select an environment"
            v-model="selected"
          >
            <option selected>Select an environment</option>
            <option value="qa">QA</option>
            <option value="stg">STG</option>
            <option value="prod">PROD</option>
          </select>
        </p>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="deleteKeyByInfoId">
            Delete
          </button>
        </div>
        <div>
          {{ deleteKeyByInfoIdResponse }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-json-pretty/lib/styles.css";
import VueJsonPretty from "vue-json-pretty";
import { analytics } from "../../config/firebaseInit";

export default {
  name: "dkdeletekeyinfo",
  components: {
    VueJsonPretty,
  },
  created() {
    analytics.logEvent("dk-delete-keyinfo");
  },
  data: function () {
    return {
      error: null,
      keyInfoId: null,
      deleteKeyByInfoIdResponse: null,
      selected: "prod",
      loading: false,
      prodURL: "https://ojjp1mt3ef.execute-api.us-west-2.amazonaws.com/staging/dkinfo",
      stageURL: "https://iawtvi82bi.execute-api.us-west-2.amazonaws.com/staging/dkinfostgtwob"
    };
  },

  methods: {
    deleteKeyByInfoId: async function () {
      this.loading = true;
      console.log(this.keyInfoId.trim());
      const config = {
        method: "delete",
        url: this.selected == "prod" ? this.prodURL : this.stageURL,
        data: {
          keyID: `${this.keyInfoId.trim()}`,
        },
      };

      this.axios(config)
        .then((response) => {
          this.loading = false;
          console.log("Request Status: ", response.data);
          this.deleteKeyByInfoIdResponse = response.data;
        })
        .catch((error) => {
          this.loading = false;
          if (error.response) {
            console.log(error.response);
            if (error.response.data.kind) {
              alert(`Well that was unexpected.  ${error.response.data.kind}`);
            } else {
              alert(`Well that was unexpected.  ${error.response.data}`);
            }
          }
        });
    },
  },
};
</script>

<style scoped>
body {
  font-family: ToyotaType-Regular;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.ty-button {
  background: #d92429;
  border-radius: 0px;
  width: 320px;
  height: 56px;
  font-family: ToyotaType-Semibold;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}

.qr-container {
  padding-top: 40px;
  text-align: center;
  height: 300px;
  /*background-color: #4281ff;*/
  height: 540px;
}

.tokenOutput {
  text-align: left !important;
}
</style>
